(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wangeditor/editor"));
	else if(typeof define === 'function' && define.amd)
		define(["@wangeditor/editor"], factory);
	else if(typeof exports === 'object')
		exports["WangEditorPluginCtrlEnter"] = factory(require("@wangeditor/editor"));
	else
		root["WangEditorPluginCtrlEnter"] = factory(root["wangEditor"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__857__) => {
return 